function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

export function validateForm(data, files) {
    let errors = {};
    if (!data.contract_number) errors.contract_number = "contract_number_error";
    if (!data.invoice_number) errors.invoice_number = "invoice_number_error";
    if (!data.email) errors.email = "email_error";
    if (!validateEmail(data.email)) errors.email = "uncorrect_email_error";
    if (!data.contact_face) errors.contact_face = "contact_face_error";
    if (!data.description) errors.description = "description_error";
    if (!data.sum) errors.sum = "sum_error";
    if (!files || !files.length) errors.files = "files_error";
    return errors;
}


export const MAX_FILE_SIZE = 200 * 1024 * 1024;
export const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/jpg", "video/mp4", "video/mkv", "video/quicktime", "application/pdf"];
